export default "__VITE_ASSET__10c08543__"